import CripNotice from "crip-vue-notice";
import { HelperNetworkCallBack } from "../mixins/Helper";
import { EventBus } from "../eventBus";

export var updateProfileNetworkCallBack = {
  mixins: [HelperNetworkCallBack],
  methods: {
    updateProfileCallBack(response) {
      if (response.data.status) {
        this.show_error_on_empty = true;
        this.is_profile_save_loading = false; //disabled save profile btn loader

        this.active_step = 2;

        this.getProfileCallBack(response);

        this.show_error_on_empty = false;

        new CripNotice({
          title: "Success",
          description: "Profile updated!",
          type: "success",
          duration: 3,
        });

        this.sebi_certificate_file = "";
        this.pan_card_file = "";
        this.aadhar_card_front_side_file = "";
        this.aadhar_card_back_side_file = "";
        this.cancelled_cheque_file = "";

        this.$root.$emit("updatedProfileData");

        if (this.changeProfessionDialog) {
          this.changeProfessionDialog = false;
          if (this.$route.name == "profileUpdate") {
            window.location.reload();
          } else {
            this.$router.push("/profile-update");
          }
        } else if (
          localStorage.getItem("premiumPlanSubscriptionDialogVisible")
        ) {
          this.$router.push({
            path: "/pricing",
          });
        } else if (
          this.profession == "Retail Investor" ||
          this.profession == "Market Expert"
        ) {
          this.$router.push("/experts-past-recommendations");
        }

        // this.$router.push('/experts-past-recommendations');
      } else {
        this.is_profile_save_loading = false; //disabled save profile btn loader
        this.show_error_on_empty = false;
      }
    },

    getProfileCallBack(response) {
      if (response.data.status) {
        this.is_profile_save_loading = false; //disabled loader

        let roles = response.data.data.user_data.roles;

        let subscribed_plan_detail = response.data.sub_plan_data
          ? response.data.sub_plan_data
          : {};
          
        let publisher_plan_detail = response.data.publisher_plan_data
          ? response.data.publisher_plan_data
          : {};

        let profile_data = JSON.parse(
          JSON.stringify(response.data.data.profile_data)
        );
        profile_data.username = response.data.data.user_data.username;

        // // save navigation to localStorage
        // response.data.data.profile_data.navigation = Object.keys(
        //   response.data.navigation
        // ).length
        //   ? response.data.navigation
        //   : "";

        this.aadhar_card_number = profile_data.aadhar_card_number;
        this.pan_card_number = profile_data.pan_card_number;
        this.risk_profiling = profile_data.risk_category;

        this.saveRolesToLocalStorage(roles);
        this.saveProfileToLocalStorage(response.data.data.profile_data);
        this.saveSubscribedPlanDetailsToLocalStorage(subscribed_plan_detail);
        this.saveSubscribedPublisherPlanDetails(publisher_plan_detail);

        this.full_name = profile_data.full_name ? profile_data.full_name : "";
        // this.last_name = profile_data.last_name ? profile_data.last_name : '';
        this.email =
          !profile_data.email_verified &&
          profile_data.profession == "Retail Investor"
            ? ""
            : profile_data.email
            ? profile_data.email
            : "";
        this.mobile = profile_data.mobile ? profile_data.mobile : "";
        this.address = profile_data.address;
        this.profession = profile_data.profession
          ? profile_data.profession
          : "";

        // this.profession = 'Retail Investor';
        this.about = profile_data.about_us;
        // this.invesment_expe = profile_data.invesment_expe ? profile_data.invesment_expe : '';
        // this.invesment_objective = profile_data.invesment_objective ? profile_data.invesment_objective : '';
        this.company = profile_data.company ? profile_data.company : "";
        this.sebi_regi_number = profile_data.sebi_regi_number
          ? profile_data.sebi_regi_number
          : "";
        this.institute_name = profile_data.institute_name
          ? profile_data.institute_name
          : "";
        this.gst_no = profile_data.gst_number ? profile_data.gst_number : "";

        this.is_mobile_verified = profile_data.mobile_verified;
        this.is_email_verified = profile_data.email_verified;

        this.website = profile_data.website;
        this.gmail_link = profile_data.gmail;
        this.facebook_link = profile_data.facebook;
        this.linkedin_link = profile_data.linkedin;
        this.telegram_link = profile_data.telegram;
        this.youtube_link = profile_data.youtube;

        // for kyc documents
        this.is_sebi_certificate_uploaded =
          profile_data.sebi_certificate_status;
        this.is_pan_card_uploaded = profile_data.pan_card_status;
        this.is_aadhar_card_uploaded = profile_data.aadhar_card_status;
        this.is_nism_uploaded = profile_data.nism_certificate_status;

        this.sebi_registration_number = profile_data.sebi_regi_number
          ? profile_data.sebi_regi_number
          : "";
        this.dealer_registration_number = profile_data.broker_registration_no
          ? profile_data.broker_registration_no
          : "";

        this.selectedBrokers = profile_data.dealer_of;

        EventBus.$emit("userData", response.data.data.profile_data); //emitted event to update UserData at navbar, sidebar

        if (profile_data.picture && profile_data.picture.length) {
          this.profile_pic = this.serverHostName + profile_data.picture;
        }
        if (profile_data.cover_image && profile_data.cover_image.length) {
          this.cover_image = this.serverHostName + profile_data.cover_image;
        }

        this.$root.$emit("updatedProfileData");
      } else {
        // this.show_error_on_empty = false;
      }
    },
  },
};
